import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { getRetiredAboutList } from "../../services/about/about.service";
import { IMAGE_BASE_URL } from "../../services/base.service";
import ReactBootstrapCarousel from "react-bootstrap-carousel";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import Title from "../../components/title";
import styles from "./Retired.module.css";

let unlisten;
const RetiredAbout = ({ history }) => {
  const imgRef = useRef();
  const [aboutList, setAboutList] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [tabContent, setTabContent] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  let { search } = useLocation();

  const query = new URLSearchParams(search);
  const tabIndex = query.get("t");

  const toggleModal = (e) => {
    setShowModal(true);

    let elSrc = null;

    if (e.target.hasAttribute("src")) {
      elSrc = e.target.src;
    } else {
      elSrc = e.target.querySelector("img").src;
    }

    setTimeout(() => {
      document.getElementById("modal-about-source").src = elSrc;
    }, 10);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    setBreadCrumbItems([
      { title: "خانه", url: "/" },
      { title: "درباره بازنشتگان", url: "/retired/about" },
    ]);
    getRetiredAboutList().then(({ data }) => {
      setAboutList((data && data.data) || []);
      unlisten = history.listen(() => {
        if (window.location.href.indexOf("?t=") >= 0) {
          const tIndex = parseInt(window.location.href.split("?t=")[1]);
          if (
            tIndex &&
            !isNaN(tIndex) &&
            tIndex >= 1 &&
            tIndex <= ((data && data.data) || []).length
          ) {
            const replacedImageText = data.data[tIndex - 1].context.replaceAll(
              '<img src="',
              '<img src="' + IMAGE_BASE_URL + ""
            );
            setTabContent(replacedImageText);
            setActiveIndex(tIndex - 1);
          }
        }
      });
      try {
        if (
          !tabIndex ||
          isNaN(tabIndex) ||
          tabIndex < 1 ||
          (data && data.data && []).length > 0
        ) {
          const replacedImageText = data.data[0].context.replaceAll(
            '<img src="',
            '<img src="' + IMAGE_BASE_URL + ""
          );
          setTabContent(replacedImageText);
        } else {
          const replacedImageText = data.data[tabIndex - 1].context.replaceAll(
            '<img src="',
            '<img src="' + IMAGE_BASE_URL + ""
          );
          setTabContent(replacedImageText);
          setActiveIndex(tabIndex - 1);
        }
      } catch (e) {}
    });
    return () => {
      try {
        unlisten();
      } catch (e) {}
    };
  }, [history, tabIndex]);

  const changeTab = (index) => {
    const replacedImageText = aboutList[index].context.replaceAll(
      '<img src="',
      '<img src="' + IMAGE_BASE_URL + ""
    );
    setTabContent(replacedImageText);
    setActiveIndex(index);
    history.push({
      pathname: "/retired/about",
      search: "?t=" + (parseInt(index) + 1),
    });
  };
  return (
    <>
      <Title title={"درباره بازنشتگان"} />
      {showModal ? (
        <>
          <div id="modal-backdrop" onClick={closeModal}></div>
          <div id="modal-wrapper">
            <div className={"modal-close"} onClick={closeModal}>
              &#x2715;
            </div>
            <img
              src={""}
              id="modal-about-source"
              ref={imgRef}
              alt={"about source"}
            />
          </div>
        </>
      ) : null}
      <div className="clearfix"></div>
      <div className={"container"}>
        <BreadCrumb items={breadCrumbItems} />
        <div className={"row"}>
          <div className={"col-xs-12 col-md-9"}>
            {aboutList &&
            aboutList.length > 0 &&
            aboutList[activeIndex].attachment_files.length > 0 ? (
              <div className={styles.aboutImageWrapper}>
                {aboutList[activeIndex].attachment_files.length > 1 ? (
                  <ReactBootstrapCarousel>
                    {aboutList[activeIndex].attachment_files.map(
                      (item, index) => (
                        <div
                          className={styles.elWrapper}
                          onClick={(e) => toggleModal(e)}
                        >
                          <SliderElem
                            item={item}
                            key={index + "-slider-main-elem"}
                            isActive={index === 0 ? true : false}
                          />
                        </div>
                      )
                    )}
                  </ReactBootstrapCarousel>
                ) : (
                  <img
                    src={
                      aboutList[activeIndex].attachment_files[0]
                        .server_relative_url
                    }
                    alt={"about"}
                  />
                )}
              </div>
            ) : null}
            {tabContent ? (
              <div
                id={styles.tabContent}
                dangerouslySetInnerHTML={{ __html: tabContent }}
              ></div>
            ) : (
              <div className={styles.loadingWrapper}>
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
          <div className={"col-xs-12 col-md-3"}>
            <h2 className={styles.sidebarAboutTitle}>درباره شرکت</h2>
            {aboutList && aboutList.length > 0 ? (
              <ul id={styles.aboutTabSide}>
                {aboutList.map((item, index) => (
                  <li
                    className={index === activeIndex ? styles.active : null}
                    onClick={() => changeTab(index)}
                    key={index + "-key-tab-box"}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            ) : (
              <div className="loading-wrapper">
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
const SliderElem = ({ item, isActive }) => {
  return (
    <div
      className={
        isActive
          ? `${styles.item} ${styles.active} ${styles.aboutCarousel}`
          : `${styles.item} ${styles.aboutCarousel}`
      }
    >
      <img src={item.server_relative_url} alt={"about carousel"} />
    </div>
  );
};
export default RetiredAbout;
